import type { ICatalog } from '@platform/core/types';
import { moduleNav } from '@platform/navigation';
import { installedHere } from './installedHere';

/**
 * «N модулів» робочого простору там, де прототип v4 рахує ws.modules — кожен реалізований тип запису («Усі модулі · 169» на панелі,
 * меню й навігатор просторів: «481 учасник · 169 модулів», плитка «Модулі» налаштувань): сума реалізованих типів записів встановлених
 * модулів (types моделі навігації; невідомий модуль — 1), зокрема вимкнених глобально (ADR-027: модуль лишається в ws.modules, його лише
 * не видно в меню). Каталог ще не завантажено — undefined. Чиста функція.
 */
export function recordTypeTotal(catalog: ICatalog | undefined): number | undefined {
  return catalog?.modules.filter(installedHere).reduce((n, m) => n + (moduleNav(m.key).types ?? 1), 0);
}
